import {
    Timeline,
    timelineConnectorClasses,
    timelineDotClasses,
    timelineItemClasses,
    timelineSeparatorClasses,
} from '@mui/lab';

const ActivityTimeLine = ({ children }) => {
    return (
        <Timeline
            sx={{
                p: 0,
                m: 0,
                [`& .${timelineItemClasses.root}`]: {
                    ': last-child': {
                        [`& .${timelineConnectorClasses.root}`]: {
                            display: 'none',
                        },
                    },
                    ': before': {
                        flex: 0,
                        padding: 0,
                    },
                },
                [`& .${timelineSeparatorClasses.root}`]: {
                    minWidth: '2rem',
                },
                [`& .${timelineDotClasses.root}`]: {
                    mx: 'auto',
                },
            }}
        >
            {children}
        </Timeline>
    );
};

export default ActivityTimeLine;
